<template>
  <div class="orderMain">
    <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
      <el-tab-pane label="会员列表" name="first" v-if="tabTrue1">
        <div>
          <div class="title_div">
            <span class="title-span">门店:</span>
            <el-select
              filterable
              clearable
              v-model="hyParams.shopId"
              size="small"
              class="title-select"
              @change="mdStortChange"
            >
              <el-option
                v-for="item in this.mdSelectList"
                :label="item.name"
                :value="item.id"
                :key="item.id"
              ></el-option>
            </el-select>
            <span class="title-span">会员等级:</span>
            <el-select
              clearable
              v-model="hyParams.levelId"
              size="small"
              class="title-select"
              @change="djStortChange"
            >
              <el-option
                v-for="item in this.djSelectList"
                :label="item.cardName"
                :value="item.id"
                :key="item.id"
              ></el-option>
            </el-select>

            <span class="title-span">归属:</span>
            <el-select
              clearable
              v-model="hyParams.userID"
              size="small"
              class="title-select"
              filterable
              remote
              :loading="loading"
              :remote-method="remoteMethod"
              @change="dyStortChange"
            >
              <el-option
                v-for="item in this.jlSelectList"
                :label="item.realname"
                :value="item.userId"
                :key="item.userId"
              ></el-option>
            </el-select>

            <br />
            <span class="title-span">开卡时间:</span>
            <el-date-picker
              @change="hyStartChange"
              v-model="hyParams.createDateStart"
              size="small"
              class="title-date1"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择开始日期"
            >
            </el-date-picker>
            至
            <el-date-picker
              @change="hyEndChange"
              v-model="hyParams.createDateEnd"
              size="small"
              class="title-date2"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择结束日期"
            >
            </el-date-picker>
            <span class="title-span">会员:</span>
            <el-input
              size="small"
              style="width: 200px; margin-left: 20px; margin-top: 20px"
              v-model="hyParams.queryValue"
              placeholder="会员电话、姓名、会员卡号"
              clearable
              @input="hyMemberInfo"
            ></el-input>
          </div>
          <div style="text-align: right">
            <!--            <el-button class="creat-button" type="primary" size="small" @click="creathyDialogVisible=true">新建会员-->
            <!--            </el-button>-->
            <!-- <el-button
              class="out-button"
              type="primary"
              size="small"
              @click="copyAll"
              >批量导出
            </el-button> -->
          </div>
          <div class="mm-tb">
            <el-table :data="hyList" style="width: 100%">
              <el-table-column
                type="index"
                label="序号"
                align="center"
                width="80"
              >
              </el-table-column>
              <el-table-column
                prop="memberName"
                label="会员姓名"
                align="center"
              >
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    size="medium"
                    @click="infoOne(scope.row.id)"
                    >{{ scope.row.memberName }}
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column
                prop="memberMobile"
                label="手机号码"
                align="center"
              >
              </el-table-column>
              <el-table-column prop="levelName" label="会员等级" align="center">
              </el-table-column>
              <el-table-column prop="points" label="会员积分" align="center">
              </el-table-column>
              <el-table-column prop="shopName" label="门店" align="center">
              </el-table-column>
              <el-table-column
                prop="createUserName"
                label="归属人"
                align="center"
              >
              </el-table-column>
              <el-table-column prop="address" label="开卡日期" align="center">
                <template slot-scope="scope">{{
                  scope.row.createDate.substring(0, 10)
                }}</template>
              </el-table-column>
              <el-table-column prop="address" align="center" label="操作">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    size="medium"
                    @click="copyOne(scope.row)"
                    >复制</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div>
            <el-pagination
              class="mm-page"
              @size-change="hySizeChange"
              @current-change="hyCurrentChange"
              :current-page="hyResult.current"
              :page-size="hyResult.size"
              layout="total,prev, pager, next, sizes"
              :total="hyResult.total"
              :page-sizes="[10, 20, 30, 40, 50]"
            >
            </el-pagination>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="会员营销" name="second" v-if="tabTrue2">
      </el-tab-pane>
      <el-tab-pane label="会员列表管理" name="three" v-if="tabTrue3">
      </el-tab-pane>
    </el-tabs>
    <el-dialog
      title="会员详情"
      :visible.sync="seehyDialogVisible"
      width="750px"
      :close-on-click-modal="false"
    >
      <el-tabs v-model="activeName1">
        <el-tab-pane label="基本信息" name="first">
          <div class="clearfix">
            <div class="leftDiv" style="float: left">
              <!--              <div class="dialog-div">-->
              <!--                <span class="title-span">会 员 卡 号:</span>-->
              <!--                <el-input size="small" class="title-select" v-model="hySeeParams.memberName"></el-input>-->
              <!--              </div>-->
              <div class="dialog-div">
                <span class="title-span">会 员 卡 号:</span>
                <el-input
                  size="small"
                  class="title-select"
                  v-model="hySeeParams.memberCardSn"
                  disabled
                ></el-input>
              </div>
              <div class="dialog-div">
                <span class="title-span">会 员 姓 名:</span>
                <el-input
                  size="small"
                  class="title-select"
                  v-model="hySeeParams.memberName"
                  disabled
                ></el-input>
              </div>
              <div class="dialog-div">
                <span class="title-span"
                  >手&nbsp;&nbsp;&nbsp;机&nbsp;&nbsp;&nbsp;号:</span
                >
                <el-input
                  size="small"
                  class="title-select"
                  v-model="hySeeParams.memberMobile"
                  disabled
                ></el-input>
              </div>
              <div class="dialog-div">
                <span class="title-span">出 生 日 期:</span>
                <!--            <el-input size="small" class="title-select" v-model="hyCreatParams.memberBirthday"></el-input>-->
                <el-date-picker
                  type="date"
                  size="small"
                  class="title-select"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                  v-model="hySeeParams.memberBirthday"
                  disabled
                ></el-date-picker>
              </div>
              <div class="dialog-div">
                <span class="title-span">身 份 证 号:</span>
                <el-input
                  size="small"
                  class="title-select"
                  v-model="hySeeParams.memberSfnum"
                  disabled
                ></el-input>
              </div>
            </div>
            <div class="rightDiv" style="float: left">
              <div class="dialog-div">
                <span class="title-span">会 员 照 片:</span>
                <div>
                  <img
                    v-if="creatImageUrl"
                    :src="creatImageUrl"
                    class="avatar"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="dialog-div clearfix" v-if="honours.length > 0">
            <span class="title-span" style="float: left">会 员 荣 誉:</span>
            <el-checkbox-group
              v-model="honours"
              size="mini"
              style="float: left; margin-left: 20px"
            >
              <el-checkbox-button
                v-for="item in vipHonor"
                :label="item.id"
                :key="item.id"
                >{{ item.honourName }}
              </el-checkbox-button>
            </el-checkbox-group>
          </div>
          <div class="dialog-div clearfix">
            <span class="title-span" style="float: left">会 员 备 注:</span>
            <el-input
              type="textarea"
              style="
                float: left;
                margin-left: 20px;
                width: 600px;
                margin-top: 10px;
              "
              v-model="hySeeParams.remark"
              disabled
            ></el-input>
          </div>
          <div class="dialog-div clearfix">
            <span class="title-span">当 前 等 级:</span>
            <el-select
              clearable
              v-model="hySeeParams.levelId"
              placeholder="请选择会员等级"
              size="small"
              class="title-select"
              disabled
            >
              <el-option
                v-for="item in djSelectList"
                :key="item.id"
                :label="item.cardName"
                :value="item.id"
              ></el-option>
            </el-select>
          </div>
          <div class="dialog-div clearfix">
            <div style="width: 33%; float: left">
              <span>积分:{{ hySeeParams.points }}</span>
            </div>
            <div style="width: 33%; float: left">
              <span>储值金额(元):{{ hySeeParams.balance }}</span>
            </div>
            <div style="width: 33%; float: left">
              <span>能量值:{{ hySeeParams.power }}</span>
            </div>
          </div>
          <div class="dialog-div clearfix">
            <div style="width: 33%; float: left">
              <span>箭票(组):{{ hySeeParams.arrowTicket }}</span>
            </div>
            <div style="width: 33%; float: left">
              <span>赠送储值(元):{{ hySeeParams.giveStore }}</span>
            </div>
            <div style="width: 33%; float: left">
              <span>电子卡(组):{{ hySeeParams.electronicCard }}</span>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="会员流水" name="second">
          <el-tabs
            v-model="activeName2"
            type="border-card"
            style="margin-bottom: 20px"
          >
            <el-tab-pane label="积分" name="first">
              <el-table :data="jfList" style="width: 100%">
                <el-table-column
                  type="index"
                  label="序号"
                  align="center"
                  width="80"
                >
                </el-table-column>
                <el-table-column
                  prop="createDate"
                  label="变化时间"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="memberMobile"
                  label="变化数量"
                  align="center"
                >
                  <template slot-scope="scope">{{
                    (parseInt(scope.row.newValue * 10) -
                      parseInt(scope.row.oldValue * 10)) /
                    10
                  }}</template>
                </el-table-column>
                <el-table-column
                  prop="newValue"
                  label="当前积分"
                  align="center"
                >
                </el-table-column>
                <el-table-column prop="remarks" label="变化原因" align="center">
                </el-table-column>
              </el-table>
              <el-pagination
                class="mm-page"
                @size-change="jfSizeChange"
                @current-change="jfCurrentChange"
                :current-page="jfResult.current"
                :page-size="jfResult.size"
                layout="total,prev, pager, next, sizes"
                :total="jfResult.total"
                :page-sizes="[10, 20, 30, 40, 50]"
              >
              </el-pagination>
            </el-tab-pane>
            <el-tab-pane label="箭票" name="second">
              <el-table :data="jpList" style="width: 100%">
                <el-table-column
                  type="index"
                  label="序号"
                  align="center"
                  width="80"
                >
                </el-table-column>
                <el-table-column
                  prop="createDate"
                  label="变化时间"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="memberMobile"
                  label="变化数量"
                  align="center"
                >
                  <template slot-scope="scope">{{
                    scope.row.newValue - scope.row.oldValue
                  }}</template>
                </el-table-column>
                <el-table-column
                  prop="newValue"
                  label="当前箭票"
                  align="center"
                >
                </el-table-column>
                <el-table-column prop="remarks" label="变化原因" align="center">
                </el-table-column>
              </el-table>
              <el-pagination
                class="mm-page"
                @size-change="jpSizeChange"
                @current-change="jpCurrentChange"
                :current-page="jpResult.current"
                :page-size="jpResult.size"
                layout="total,prev, pager, next, sizes"
                :total="jpResult.total"
                :page-sizes="[10, 20, 30, 40, 50]"
              >
              </el-pagination>
            </el-tab-pane>
            <el-tab-pane label="电子卡" name="shree">
              <el-table :data="dzqList" style="width: 100%">
                <el-table-column
                  type="index"
                  label="序号"
                  align="center"
                  width="80"
                >
                </el-table-column>
                <el-table-column
                  prop="createDate"
                  label="变化时间"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="memberMobile"
                  label="变化数量"
                  align="center"
                >
                  <template slot-scope="scope">{{
                    scope.row.newValue - scope.row.oldValue
                  }}</template>
                </el-table-column>
                <el-table-column
                  prop="newValue"
                  label="当前电子卡"
                  align="center"
                >
                </el-table-column>
                <el-table-column prop="remarks" label="变化原因" align="center">
                </el-table-column>
              </el-table>
              <el-pagination
                class="mm-page"
                @size-change="dzqSizeChange"
                @current-change="dzqCurrentChange"
                :current-page="dzqResult.current"
                :page-size="dzqResult.size"
                layout="total,prev, pager, next, sizes"
                :total="dzqResult.total"
                :page-sizes="[10, 20, 30, 40, 50]"
              >
              </el-pagination>
            </el-tab-pane>
            <el-tab-pane label="储值" name="four">
              <el-table :data="czList" style="width: 100%">
                <el-table-column
                  type="index"
                  label="序号"
                  align="center"
                  width="80"
                >
                </el-table-column>
                <el-table-column
                  prop="createDate"
                  label="变化时间"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="memberMobile"
                  label="变化数量"
                  align="center"
                >
                  <template slot-scope="scope">{{
                    (parseInt(scope.row.newValue * 100) -
                      parseInt(scope.row.oldValue * 100)) /
                    100
                  }}</template>
                </el-table-column>
                <!-- <el-table-column prop="oldValue" label="原储值" align="center"> 
                </el-table-column>-->
                <el-table-column
                  prop="newValue"
                  label="当前储值"
                  align="center"
                >
                </el-table-column>
                <el-table-column prop="remarks" label="变化原因" align="center">
                </el-table-column>
              </el-table>
              <el-pagination
                class="mm-page"
                @size-change="czSizeChange"
                @current-change="czCurrentChange"
                :current-page="czResult.current"
                :page-size="czResult.size"
                layout="total,prev, pager, next, sizes"
                :total="czResult.total"
                :page-sizes="[10, 20, 30, 40, 50]"
              >
              </el-pagination>
            </el-tab-pane>
            <el-tab-pane label="赠储" name="five">
              <el-table :data="zcList" style="width: 100%">
                <el-table-column
                  type="index"
                  label="序号"
                  align="center"
                  width="80"
                >
                </el-table-column>
                <el-table-column
                  prop="createDate"
                  label="变化时间"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="memberMobile"
                  label="变化数量"
                  align="center"
                >
                  <template slot-scope="scope">{{
                    scope.row.newValue - scope.row.oldValue
                  }}</template>
                </el-table-column>
                <el-table-column
                  prop="newValue"
                  label="当前赠储"
                  align="center"
                >
                </el-table-column>
                <el-table-column prop="remarks" label="变化原因" align="center">
                </el-table-column>
              </el-table>
              <el-pagination
                class="mm-page"
                @size-change="zcSizeChange"
                @current-change="zcCurrentChange"
                :current-page="zcResult.current"
                :page-size="zcResult.size"
                layout="total,prev, pager, next, sizes"
                :total="zcResult.total"
                :page-sizes="[10, 20, 30, 40, 50]"
              >
              </el-pagination>
            </el-tab-pane>
            <el-tab-pane label="寄存" name="six">
              <el-table :data="jcList" style="width: 100%">
                <el-table-column
                  type="index"
                  label="序号"
                  align="center"
                  width="80"
                >
                </el-table-column>
                <el-table-column
                  prop="saveStartDate"
                  label="寄存日期"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="saveEndDate"
                  label="到期日期"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="timeRemaining"
                  label="剩余天数"
                  align="center"
                >
                </el-table-column>
                <el-table-column prop="shopName" label="门店" align="center">
                </el-table-column>
                <el-table-column prop="cashPledge" label="押金" align="center">
                </el-table-column>
                <el-table-column
                  prop="returnStatus"
                  label="状态"
                  align="center"
                >
                  <template slot-scope="scope">
                    <div v-if="scope.row.returnStatus == 1">已退</div>
                    <div v-if="scope.row.returnStatus == 0">未退</div>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                class="mm-page"
                @size-change="jcSizeChange"
                @current-change="jcCurrentChange"
                :current-page="jcResult.current"
                :page-size="jcResult.size"
                layout="total,prev, pager, next, sizes"
                :total="jcResult.total"
                :page-sizes="[10, 20, 30, 40, 50]"
              >
              </el-pagination>
            </el-tab-pane>
            <el-tab-pane label="能量值" name="seven">
              <el-table :data="nlList" style="width: 100%">
                <el-table-column
                  type="index"
                  label="序号"
                  align="center"
                  width="80"
                >
                </el-table-column>
                <el-table-column
                  prop="createDate"
                  label="变化时间"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="memberMobile"
                  label="变化数量"
                  align="center"
                >
                  <template slot-scope="scope">{{
                    scope.row.newValue - scope.row.oldValue
                  }}</template>
                </el-table-column>
                <el-table-column
                  prop="newValue"
                  label="当前能量值"
                  align="center"
                >
                </el-table-column>
                <el-table-column prop="remarks" label="变化原因" align="center">
                </el-table-column>
              </el-table>
              <el-pagination
                class="mm-page"
                @size-change="nlSizeChange"
                @current-change="nlCurrentChange"
                :current-page="nlResult.current"
                :page-size="nlResult.size"
                layout="total,prev, pager, next, sizes"
                :total="nlResult.total"
                :page-sizes="[10, 20, 30, 40, 50]"
              >
              </el-pagination>
            </el-tab-pane>
            <el-tab-pane label="会员等级" name="eight">
              <el-table :data="djList" style="width: 100%">
                <el-table-column
                  type="index"
                  label="序号"
                  align="center"
                  width="80"
                >
                </el-table-column>
                <el-table-column
                  prop="createDate"
                  label="变化时间"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="oldName"
                  label="原等级"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="newName"
                  label="当前等级"
                  align="center"
                >
                </el-table-column>
                <el-table-column prop="remarks" label="变化原因" align="center">
                </el-table-column>
              </el-table>
              <el-pagination
                class="mm-page"
                @size-change="djSizeChange"
                @current-change="djCurrentChange"
                :current-page="djResult.current"
                :page-size="djResult.size"
                layout="total,prev, pager, next, sizes"
                :total="djResult.total"
                :page-sizes="[10, 20, 30, 40, 50]"
              >
              </el-pagination>
            </el-tab-pane>
            <!--  -->
            <el-tab-pane label="会员姓名" name="nine">
              <el-table :data="infomemberParamsList" style="width: 100%">
                <el-table-column
                  type="index"
                  label="序号"
                  align="center"
                  width="80"
                >
                </el-table-column>
                <el-table-column
                  prop="createDate"
                  label="变化时间"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="oldName"
                  label="原值"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="newName"
                  label="当前值"
                  align="center"
                >
                </el-table-column>
                <el-table-column prop="remarks" label="变化原因" align="center">
                </el-table-column>
              </el-table>
              <el-pagination
                class="mm-page"
                @size-change="infomemberSizeChange"
                @current-change="infomemberCurrentChange"
                :current-page="infomemberParams.current"
                :page-size="infomemberParams.size"
                layout="total,prev, pager, next, sizes"
                :total="infomemberParamsResult.total"
                :page-sizes="[10, 20, 30, 40, 50]"
              >
              </el-pagination>
            </el-tab-pane>
            <!--  -->
          </el-tabs>
        </el-tab-pane>
      </el-tabs>

      <!--      <span slot="footer" class="dialog-footer">-->
      <!--              <el-button @click="seehyDialogVisible = false">取 消</el-button>-->
      <!--              <el-button type="primary" @click="creathyCommit">确 定</el-button>-->
      <!--            </span>-->
    </el-dialog>
  </div>
</template>

<script>
import { globelurl, posturl } from "../../api/axios";
import {
  getAntMembersPage,
  getUserForSelect,
  addAntMembers,
  getAntMembersForExcel,
  getCoachListForSelect,
} from "../../api/MemberManagement";
import {
  getAntDeptSelect,
  getMembersCardLevelSelect,
  getHonourList,
  getAntMemberById,
  getAntMembersChangePage,
} from "../../api/BusinessManagement";
import { getStorageRegisterList } from "../../api/OrderManagement";
import { hasbtn } from "@/utils/commondata";
export default {
  name: "MemberLlist",
  data() {
    return {
      activeName: "first",
      activeName1: "first",
      activeName2: "first",
      headers: { "X-Access-Token": sessionStorage.token },
      upLoadUrl: posturl,
      hyParams: {
        createDateStart: "",
        createDateEnd: "",
        shopId: "",
        levelId: "",
        userID: "",
        pageNo: 1,
        pageSize: 10,
        queryValue: "",
      },
      creatImageUrl: "",
      hySeeParams: {
        memberName: "",
        memberMobile: "",
        memberBirthday: "",
        memberSfnum: "",
        shopId: "",
        levelId: "",
        balance: "",
        giveStore: "",
        electronicCard: "",
        photoData: "",
        createUserId: "",
        points: "",
        power: "",
        arrowTicket: "",
        electronicCardDays: "",
        honourIds: "",
        remark: "",
        // points: "",
        // balance: "",
        // power: "",
        // arrowTicket: "",
        // giveStore: "",
        // electronicCard: "",
      },
      hyResult: {},
      hyList: [],
      mdSelectList: [],
      jlSelectList: [],
      djSelectList: [],
      cVipDialogFlag: false,
      seehyDialogVisible: false,
      honours: [],
      vipHonor: [],
      jfList: [],
      jfResult: {},
      jfParams: {
        changeType: 1,
        memberId: "",
        pageNo: 1,
        pageSize: 10,
      },
      jpList: [],
      jpResult: {},
      jpParams: {
        changeType: 2,
        memberId: "",
        pageNo: 1,
        pageSize: 10,
      },
      dzqList: [],
      dzqResult: {},
      dzqParams: {
        changeType: 3,
        memberId: "",
        pageNo: 1,
        pageSize: 10,
      },
      czList: [],
      czResult: {},
      czParams: {
        changeType: 4,
        memberId: "",
        pageNo: 1,
        pageSize: 10,
      },
      zcList: [],
      zcResult: {},
      zcParams: {
        changeType: 5,
        memberId: "",
        pageNo: 1,
        pageSize: 10,
      },
      jcList: [],
      jcResult: {},
      jcParams: {
        memberId: "",
        pageNo: 1,
        pageSize: 10,
      },
      nlList: [],
      nlResult: {},
      nlParams: {
        changeType: 6,
        memberId: "",
        pageNo: 1,
        pageSize: 10,
      },
      djList: [],
      djResult: {},
      djParams: {
        changeType: 7,
        memberId: "",
        pageNo: 1,
        pageSize: 10,
      },
      infomemberParamsList: [],
      infomemberParamsResult: {},
      infomemberParams: {
        changeType: 8,
        memberId: "",
        pageNo: 1,
        pageSize: 10,
      },
      tabTrue1: false,
      tabTrue2: false,
      tabTrue3: false,
      loading: false,
    };
  },
  mounted() {
    this.getAntMembersPage(this.hyParams);
    this.getAntDeptSelect();
    this.getMembersCardLevelSelect();
    this.getHonourList();
    this.getUserByShop();
    this.tabTrue1 = hasbtn(
      this.$router.options.routes[1].children,
      "/MemberManagement/MemberLlist"
    );
    this.tabTrue2 = hasbtn(
      this.$router.options.routes[1].children,
      "/MemberManagement/MemberMarketing"
    );
    this.tabTrue3 = hasbtn(
      this.$router.options.routes[1].children,
      "/MemberManagement/MemberLlistManagement"
    );
  },
  methods: {
    handleClick(tab, event) {
      if (tab.label == "会员列表") {
      } else if (tab.label == "会员营销") {
        this.$router.push("/MemberManagement/MemberMarketing");
      } else if (tab.label == "会员列表管理") {
        this.$router.push("/MemberManagement/MemberLlistManagement");
      }
    },
    //获取会员列表
    getAntMembersPage(params) {
      getAntMembersPage(params).then((res) => {
        if (res.status === 200 && res.data.success) {
          if (res.data.result.total === 0) {
            this.$Notice.open({
              title: "查无数据",
            });
            this.hyResult = res.data.result;
            this.hyList = res.data.result.records;
          } else {
            this.hyResult = res.data.result;
            this.hyList = res.data.result.records;
          }
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    hySizeChange(newSize) {
      this.hyParams.pageSize = newSize;
      this.getAntMembersPage(this.hyParams);
    },
    hyCurrentChange(newPage) {
      this.hyParams.pageNo = newPage;
      this.getAntMembersPage(this.hyParams);
    },
    //获取门店下拉菜单
    getAntDeptSelect() {
      getAntDeptSelect().then((res) => {
        if (res.status === 200 && res.data.success) {
          if (res.data.result.total === 0) {
            this.$Notice.open({
              title: "查无数据",
            });
          } else {
            this.mdSelectList = res.data.result;
          }
        }
      });
    },
    //门店下拉菜单改变
    mdStortChange(val) {
      this.hyParams.pageNo = 1;
      this.getAntMembersPage(this.hyParams);
      // this.getUserByShop(val);
    },
    //获取会员等级下拉列表
    getMembersCardLevelSelect() {
      getMembersCardLevelSelect().then((res) => {
        if (res.status === 200 && res.data.success) {
          if (res.data.result.total === 0) {
            this.$Notice.open({
              title: "查无数据",
            });
          } else {
            this.djSelectList = res.data.result;
          }
        }
      });
    },
    remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          getCoachListForSelect({ queryValue: query }).then((res) => {
            if (res.status === 200 && res.data.success) {
              this.jlSelectList = res.data.result;
            }
          });
        }, 200);
      } else {
        this.jlSelectList = [];
      }
    },
    //门店下拉菜单改变
    djStortChange(val) {
      this.hyParams.pageNo = 1;
      this.getAntMembersPage(this.hyParams);
    },
    //归属筛选下拉
    dyStortChange(val) {
      if (val === "") {
        this.getUserByShop();
      }
      this.hyParams.pageNo = 1;
      this.getAntMembersPage(this.hyParams);
    },
    // 会员模糊搜索
    hyMemberInfo() {
      this.hyParams.pageNo = 1;
      this.getAntMembersPage(this.hyParams);
    },
    //店员下拉
    getUserByShop(shopId) {
      // getUserForSelect({ shopId: shopId }).then((res) => {
      getUserForSelect({ queryAll: 1 }).then((res) => {
        if (res.status === 200 && res.data.success) {
          if (res.data.result.total === 0) {
            this.$Notice.open({
              title: "查无数据",
            });
          } else {
            this.jlSelectList = res.data.result;
          }
        }
      });
    },
    //会员开始时间改变
    hyStartChange() {
      if (
        this.hyParams.createDateStart &&
        this.hyParams.createDateEnd &&
        new Date(this.hyParams.createDateStart).getTime() >
          new Date(this.hyParams.createDateEnd).getTime()
      ) {
        this.$message.error("开始时间不能大于结束时间");
        return;
      }
      this.hyParams.pageNo = 1;
      this.getAntMembersPage(this.hyParams);
    },
    //会员结束时间改变
    hyEndChange() {
      if (
        this.hyParams.createDateStart &&
        this.hyParams.createDateEnd &&
        new Date(this.hyParams.createDateStart).getTime() >
          new Date(this.hyParams.createDateEnd).getTime()
      ) {
        this.$message.error("开始时间不能大于结束时间");
        return;
      }
      this.hyParams.pageNo = 1;
      this.getAntMembersPage(this.hyParams);
    },
    //复制一条
    copyOne(r) {
      //console.log(r)
      var text =
        "会员姓名:" +
        r.memberName +
        ";手机号码:" +
        r.memberMobile +
        ";会员等级:" +
        r.levelName +
        ";会员积分:" +
        r.points +
        ";门店:" +
        r.shopName +
        ";归属人:" +
        r.createUserName +
        ";开卡日期:" +
        r.createDate.substring(0, 10);
      this.copyText(text);
    },
    //获取文字到粘贴板
    copyText(text) {
      var textarea = document.createElement("input"); //创建input对象
      var currentFocus = document.activeElement; //当前获得焦点的元素
      document.body.appendChild(textarea); //添加元素
      textarea.value = text;
      textarea.focus();
      if (textarea.setSelectionRange) {
        textarea.setSelectionRange(0, textarea.value.length);
      } //获取光标起始位置到结束位置
      else {
        textarea.select();
      }
      try {
        var flag = document.execCommand("copy"); //执行复制
      } catch (eo) {
        var flag = false;
      }
      document.body.removeChild(textarea); //删除元素
      currentFocus.focus();
      //console.log(flag)
      if (flag) {
        this.$message.success("复制数据成功！");
      } else {
        this.$message.error(res.message);
      }
      return flag;
    },
    //批量导出
    copyAll() {
      const params = { ...this.hyParams };
      // delete params.createDateStart;
      // delete params.createDateEnd;
      // delete params.shopId;
      // delete params.levelId;
      // delete params.userID;
      getAntMembersForExcel(params).then((res) => {
        let blob = new Blob([res.data], {
          type: "application/vnd.ms-excel;charset=utf-8",
        });
        let downloadElement = document.createElement("a");
        let href = window.URL.createObjectURL(blob);
        downloadElement.href = href;
        downloadElement.download = "会员列表"; // sessionStorage.realName + timestr　　　　　　　　// xxx.xls/xxx.xlsx
        document.body.appendChild(downloadElement);
        downloadElement.click();
        document.body.removeChild(downloadElement);
        window.URL.revokeObjectURL(href);
      });
    },
    //荣誉列表
    getHonourList() {
      getHonourList().then((res) => {
        if (res.status === 200 && res.data.success) {
          this.vipHonor = res.data.result;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    //查看会员详情
    infoOne(id) {
      this.activeName1 = "first";
      this.activeName2 = "first";
      getAntMemberById({ id: id }).then((res) => {
        if (res.status === 200 && res.data.success) {
          if (res.data.result.total === 0) {
            this.$Notice.open({
              title: "查无数据",
            });
          } else {
            this.seehyDialogVisible = true;
            this.hySeeParams.memberCardSn = res.data.result.memberCardSn;
            this.hySeeParams.memberName = res.data.result.memberName;
            this.hySeeParams.memberMobile = res.data.result.memberMobile;
            this.hySeeParams.memberBirthday = res.data.result.memberBirthday;
            this.hySeeParams.memberSfnum = res.data.result.memberSfnum;
            this.hySeeParams.levelId = res.data.result.antMembersCardLevel.id;
            this.hySeeParams.remark = res.data.result.remark;
            this.hySeeParams.points = res.data.result.points;
            this.hySeeParams.balance = res.data.result.balance;
            this.hySeeParams.power = res.data.result.power;
            this.hySeeParams.arrowTicket = res.data.result.arrowTicket;
            this.hySeeParams.giveStore = res.data.result.giveStore;
            this.hySeeParams.electronicCard = res.data.result.electronicCard;
            this.creatImageUrl = globelurl + res.data.result.photoData;
            // this.honours =
            //   res.data.result.honourIds == ""
            //     ? []
            //     : res.data.result.honourIds.split(",");
            this.honours = res.data.result.honourIds
              ? res.data.result.honourIds.split(",")
              : [];
          }
        } else {
          this.$message.error(res.data.message);
        }
      });
      this.jfParams.memberId = id;
      getAntMembersChangePage(this.jfParams).then((res) => {
        if (res.status === 200 && res.data.success) {
          this.jfResult = res.data.result;
          this.jfList = res.data.result.records;
        } else {
          this.$message.error(res.data.message);
        }
      });
      this.jpParams.memberId = id;
      getAntMembersChangePage(this.jpParams).then((res) => {
        if (res.status === 200 && res.data.success) {
          this.jpResult = res.data.result;
          this.jpList = res.data.result.records;
        } else {
          this.$message.error(res.data.message);
        }
      });
      this.dzqParams.memberId = id;
      getAntMembersChangePage(this.dzqParams).then((res) => {
        if (res.status === 200 && res.data.success) {
          this.dzqResult = res.data.result;
          this.dzqList = res.data.result.records;
        } else {
          this.$message.error(res.data.message);
        }
      });
      this.czParams.memberId = id;
      getAntMembersChangePage(this.czParams).then((res) => {
        if (res.status === 200 && res.data.success) {
          this.czResult = res.data.result;
          this.czList = res.data.result.records;
        } else {
          this.$message.error(res.data.message);
        }
      });
      this.zcParams.memberId = id;
      getAntMembersChangePage(this.zcParams).then((res) => {
        if (res.status === 200 && res.data.success) {
          this.zcResult = res.data.result;
          this.zcList = res.data.result.records;
        } else {
          this.$message.error(res.data.message);
        }
      });
      this.jcParams.memberId = id;
      getStorageRegisterList(this.jcParams).then((res) => {
        if (res.status === 200 && res.data.success) {
          this.jcResult = res.data.result;
          this.jcList = res.data.result.records;
        } else {
          this.$message.error(res.data.message);
        }
      });
      this.nlParams.memberId = id;
      getAntMembersChangePage(this.nlParams).then((res) => {
        if (res.status === 200 && res.data.success) {
          this.nlResult = res.data.result;
          this.nlList = res.data.result.records;
        } else {
          this.$message.error(res.data.message);
        }
      });
      this.djParams.memberId = id;
      getAntMembersChangePage(this.djParams).then((res) => {
        if (res.status === 200 && res.data.success) {
          this.djResult = res.data.result;
          this.djList = res.data.result.records;
        } else {
          this.$message.error(res.data.message);
        }
      });
      // ----------------------------------------------------------------------------------
      this.infomemberParams.memberId = id;
      getAntMembersChangePage(this.infomemberParams).then((res) => {
        if (res.status === 200 && res.data.success) {
          this.infomemberParamsResult = res.data.result;
          this.infomemberParamsList = res.data.result.records;
        } else {
          this.$message.error(res.data.message);
        }
      });
      // ----------------------------------------------------------------------------------
    },
    //积分流水分页
    jfSizeChange(newSize) {
      this.jfParams.pageSize = newSize;
      getAntMembersChangePage(this.jfParams).then((res) => {
        if (res.status === 200 && res.data.success) {
          if (res.data.result.total === 0) {
            this.$Notice.open({
              title: "查无数据",
            });
            this.jfResult = res.data.result;
            this.jfList = res.data.result.records;
          } else {
            this.jfResult = res.data.result;
            this.jfList = res.data.result.records;
          }
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    jfCurrentChange(newPage) {
      this.jfParams.pageNo = newPage;
      getAntMembersChangePage(this.jfParams).then((res) => {
        if (res.status === 200 && res.data.success) {
          if (res.data.result.total === 0) {
            this.$Notice.open({
              title: "查无数据",
            });
            this.jfResult = res.data.result;
            this.jfList = res.data.result.records;
          } else {
            this.jfResult = res.data.result;
            this.jfList = res.data.result.records;
          }
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    //箭票流水分页
    jpSizeChange(newSize) {
      this.jpParams.pageSize = newSize;
      getAntMembersChangePage(this.jpParams).then((res) => {
        if (res.status === 200 && res.data.success) {
          if (res.data.result.total === 0) {
            this.$Notice.open({
              title: "查无数据",
            });
            this.jpResult = res.data.result;
            this.jpList = res.data.result.records;
          } else {
            this.jpResult = res.data.result;
            this.jpList = res.data.result.records;
          }
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    jpCurrentChange(newPage) {
      this.jpParams.pageNo = newPage;
      getAntMembersChangePage(this.jpParams).then((res) => {
        if (res.status === 200 && res.data.success) {
          if (res.data.result.total === 0) {
            this.$Notice.open({
              title: "查无数据",
            });
            this.jpResult = res.data.result;
            this.jpList = res.data.result.records;
          } else {
            this.jpResult = res.data.result;
            this.jpList = res.data.result.records;
          }
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    //电子卡流水分页
    dzqSizeChange(newSize) {
      this.dzqParams.pageSize = newSize;
      getAntMembersChangePage(this.dzqParams).then((res) => {
        if (res.status === 200 && res.data.success) {
          if (res.data.result.total === 0) {
            this.$Notice.open({
              title: "查无数据",
            });
            this.dzqResult = res.data.result;
            this.dzqList = res.data.result.records;
          } else {
            this.dzqResult = res.data.result;
            this.dzqList = res.data.result.records;
          }
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    dzqCurrentChange(newPage) {
      this.dzqParams.pageNo = newPage;
      getAntMembersChangePage(this.dzqParams).then((res) => {
        if (res.status === 200 && res.data.success) {
          if (res.data.result.total === 0) {
            this.$Notice.open({
              title: "查无数据",
            });
            this.dzqResult = res.data.result;
            this.dzqList = res.data.result.records;
          } else {
            this.dzqResult = res.data.result;
            this.dzqList = res.data.result.records;
          }
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    //储值流水分页
    czSizeChange(newSize) {
      this.czParams.pageSize = newSize;
      getAntMembersChangePage(this.czParams).then((res) => {
        if (res.status === 200 && res.data.success) {
          if (res.data.result.total === 0) {
            this.$Notice.open({
              title: "查无数据",
            });
            this.czResult = res.data.result;
            this.czList = res.data.result.records;
          } else {
            this.czResult = res.data.result;
            this.czList = res.data.result.records;
          }
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    czCurrentChange(newPage) {
      this.czParams.pageNo = newPage;
      getAntMembersChangePage(this.czParams).then((res) => {
        if (res.status === 200 && res.data.success) {
          if (res.data.result.total === 0) {
            this.$Notice.open({
              title: "查无数据",
            });
            this.czResult = res.data.result;
            this.czList = res.data.result.records;
          } else {
            this.czResult = res.data.result;
            this.czList = res.data.result.records;
          }
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    //赠储流水分页
    zcSizeChange(newSize) {
      this.zcParams.pageSize = newSize;
      getAntMembersChangePage(this.zcParams).then((res) => {
        if (res.status === 200 && res.data.success) {
          if (res.data.result.total === 0) {
            this.$Notice.open({
              title: "查无数据",
            });
            this.zcResult = res.data.result;
            this.zcList = res.data.result.records;
          } else {
            this.zcResult = res.data.result;
            this.zcList = res.data.result.records;
          }
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    zcCurrentChange(newPage) {
      this.zcParams.pageNo = newPage;
      getAntMembersChangePage(this.zcParams).then((res) => {
        if (res.status === 200 && res.data.success) {
          if (res.data.result.total === 0) {
            this.$Notice.open({
              title: "查无数据",
            });
            this.zcResult = res.data.result;
            this.zcList = res.data.result.records;
          } else {
            this.zcResult = res.data.result;
            this.zcList = res.data.result.records;
          }
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    //寄存流水分页
    jcSizeChange(newSize) {
      this.jcParams.pageSize = newSize;
      getStorageRegisterList(this.jcParams).then((res) => {
        if (res.status === 200 && res.data.success) {
          if (res.data.result.total === 0) {
            this.$Notice.open({
              title: "查无数据",
            });
            this.jcResult = res.data.result;
            this.jcList = res.data.result.records;
          } else {
            this.jcResult = res.data.result;
            this.jcList = res.data.result.records;
          }
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    jcCurrentChange(newPage) {
      this.jcParams.pageNo = newPage;
      getStorageRegisterList(this.jcParams).then((res) => {
        if (res.status === 200 && res.data.success) {
          if (res.data.result.total === 0) {
            this.$Notice.open({
              title: "查无数据",
            });
            this.jcResult = res.data.result;
            this.jcList = res.data.result.records;
          } else {
            this.jcResult = res.data.result;
            this.jcList = res.data.result.records;
          }
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    //能量流水分页
    nlSizeChange(newSize) {
      this.nlParams.pageSize = newSize;
      getAntMembersChangePage(this.nlParams).then((res) => {
        if (res.status === 200 && res.data.success) {
          if (res.data.result.total === 0) {
            this.$Notice.open({
              title: "查无数据",
            });
            this.nlResult = res.data.result;
            this.nlList = res.data.result.records;
          } else {
            this.nlResult = res.data.result;
            this.nlList = res.data.result.records;
          }
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    nlCurrentChange(newPage) {
      this.nlParams.pageNo = newPage;
      getAntMembersChangePage(this.nlParams).then((res) => {
        if (res.status === 200 && res.data.success) {
          if (res.data.result.total === 0) {
            this.$Notice.open({
              title: "查无数据",
            });
            this.nlResult = res.data.result;
            this.nlList = res.data.result.records;
          } else {
            this.nlResult = res.data.result;
            this.nlList = res.data.result.records;
          }
        } else {
          this.$message.error(res.data.message);
        }
      });
    },

    //会员等级流水分页
    djSizeChange(newSize) {
      this.djParams.pageSize = newSize;
      getAntMembersChangePage(this.djParams).then((res) => {
        if (res.status === 200 && res.data.success) {
          if (res.data.result.total === 0) {
            this.$Notice.open({
              title: "查无数据",
            });
            this.djResult = res.data.result;
            this.djList = res.data.result.records;
          } else {
            this.djResult = res.data.result;
            this.djList = res.data.result.records;
          }
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    djCurrentChange(newPage) {
      this.djParams.pageNo = newPage;
      getAntMembersChangePage(this.djParams).then((res) => {
        if (res.status === 200 && res.data.success) {
          if (res.data.result.total === 0) {
            this.$Notice.open({
              title: "查无数据",
            });
            this.djResult = res.data.result;
            this.djList = res.data.result.records;
          } else {
            this.djResult = res.data.result;
            this.djList = res.data.result.records;
          }
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    // 会员姓名流水分页
    infomemberSizeChange(newSize) {
      this.infomemberParams.pageSize = newSize;
      getAntMembersChangePage(this.infomemberParams).then((res) => {
        if (res.status === 200 && res.data.success) {
          if (res.data.result.total === 0) {
            this.$Notice.open({
              title: "查无数据",
            });
            this.infomemberParamsResult = res.data.result;
            this.infomemberParamsList = res.data.result.records;
          } else {
            this.infomemberParamsResult = res.data.result;
            this.infomemberParamsList = res.data.result.records;
          }
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    infomemberCurrentChange(newPage) {
      this.infomemberParams.pageNo = newPage;
      getAntMembersChangePage(this.infomemberParams).then((res) => {
        if (res.status === 200 && res.data.success) {
          if (res.data.result.total === 0) {
            this.$Notice.open({
              title: "查无数据",
            });
            this.infomemberParamsResult = res.data.result;
            this.infomemberParamsList = res.data.result.records;
          } else {
            this.infomemberParamsResult = res.data.result;
            this.infomemberParamsList = res.data.result.records;
          }
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
  },
};
</script>

<style scoped>
.title-span {
  font-size: 16px;
}

.avatar {
  width: 178px;
  height: 178px;
}

.orderMain {
  padding: 30px;
}

.title_div {
  margin: 20px 30px;
}

.title-select {
  margin: 0 20px;
  width: 200px;
}

.title-date1 {
  margin-left: 20px;
  width: 180px;
}

.title-date2 {
  width: 180px;
  margin-right: 20px;
}

.creat-button {
  margin: 20px;
}

.dialog-div {
  margin: 20px 0;
}

.out-button {
  margin-top: 20px;
  margin-right: 80px;
  margin-bottom: 20px;
}

.mm-tb {
  width: 90%;
  margin-left: 50px;
}

.mm-page {
  margin: 30px 60px;
}

.leftDiv {
  width: 50%;
  display: inline-block;
}

.rightDiv {
  width: 50%;
  padding-left: 50px;
  display: inline-block;
}
</style>

<style>
.el-dialog__body {
  padding: 0 20px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}
</style>
